export default class tab {
  constructor(opt = {}) {
  }
  init() {
  }
  tabCard(media, target) {
    let m = media;
    let $this = target;
    let $content = $this.next('.c-tab_content');
    let $tab = $this.closest('.c-tab');
    let flag = ($content.hasClass('is-open')) ? 'close' : 'open';

    if(flag == 'open'){
      if(m == 'pc') reset();
      open();
      if(m == 'pc') setPadding();
    }else{
      reset();
    }

    function changeIcon() {
      let before = ($content.hasClass('is-open')) ? 'c-icon_arrow_bottom' : 'c-icon_arrow_top';
      let after = ($content.hasClass('is-open')) ? 'c-icon_arrow_top' : 'c-icon_arrow_bottom';
      $this.find('.'+before).removeClass(before).addClass(after);
    }
    function reset() {
      if(m == 'pc'){
        $tab.removeAttr('style');
        $tab.find('.c-tab_content').removeClass('is-open');
        $tab.find('.c-tab_card').removeClass('is-current');
        $tab.find('.c-icon_arrow_top').removeClass('c-icon_arrow_top').addClass('c-icon_arrow_bottom');
      }else{
        $content.removeClass('is-open');
        $this.removeClass('is-current');
        changeIcon();
      }
    }
    function open() {
      $this.addClass('is-current');
      $content.addClass('is-open');
      changeIcon();
    }
    function setPadding() {
      let h = $content.outerHeight(true);
      $tab.css('padding-bottom', h + 'px');
    }
  }
}


// WEBPACK FOOTER //
// ./src/assets/js/modules/tab.js